import React, { ReactNode } from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';

interface InfoAlertProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  backgroundColor?: string;
  iconColor?: string;
  customIcon?: ReactNode;
}

const InfoAlert: React.FC<InfoAlertProps> = ({
  children,
  sx = {},
  iconSx = {},
  contentSx = {},
  backgroundColor = '#EFF6FF',
  iconColor = '#0066ff',
  customIcon,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        backgroundColor,
        borderRadius: 1,
        padding: '16px 20px',
        marginBottom: 4,
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          color: iconColor,
          display: 'flex',
          flexShrink: 0,
          mr: 2.5,
          mt: '2px',
          ...iconSx,
        }}
      >
        {customIcon || (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: '4px' }}
          >
            <path
              d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
              fill="currentColor"
            />
          </svg>
        )}
      </Box>

      {typeof children === 'string' ? (
        <Typography
          variant="body1"
          sx={{
            ...contentSx,
          }}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </Box>
  );
};

export default InfoAlert;